import { Component,HostListener } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';

export interface Social {
  icon: string;
  link: string;
  class: string;
}

export interface Portfolio {
  img: string;
  title: string;
  categories: string[];
  alt: string;
}

export interface Service {
  icon: string;
  title: string;
  desc: string;
}

@Component({
  selector: 'app-home-three',
  templateUrl: './home-three.component.html',
  styleUrl: './home-three.component.css'
})
export class HomeThreeComponent {
  //Header
  isTransparent = true;
  isMenuOpen = false;
  activeDropdown: number | null = null;

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  toggleDropdown(index: number): void {
    this.activeDropdown = this.activeDropdown === index ? null : index;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    this.activeDropdown = null;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.nav-item') && !target.closest('.header-toggle')) {
      this.activeDropdown = null;
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isTransparent = offset < 100;
  }
  //Header End

  // ScrollToSection
  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      const yOffset = -80; 
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }
  // Portfolio Filter
  portfolioFilters = ['All', 'Branding', 'App Development', 'Animation', 'Marketing'];
  selectedFilter = 'All';
  
  portfolioItems: Portfolio[] = [
    {
      img: 'assets/images/portfolio/gallery-2.jpg',
      title: 'Creative Ideas',
      categories: ['branding', 'animation'],
      alt: 'gallery-1'
    },
    {
      img: 'assets/images/portfolio/gallery-20.jpg',
      title: 'Magic Touch',
      categories: ['app-development', 'marketing'],
      alt: 'gallery-2'
    },
    {
      img: 'assets/images/portfolio/gallery-21.jpg',
      title: 'Data Analysis',
      categories: ['animation', 'branding'],
      alt: 'gallery-3'
    },
    {
      img: 'assets/images/portfolio/gallery-22.jpg',
      title: 'Data Analysis',
      categories: ['marketing', 'branding'],
      alt: 'gallery-4'
    },
    {
      img: 'assets/images/portfolio/gallery-23.jpg',
      title: 'Market Research',
      categories: ['app-development', 'branding'],
      alt: 'gallery-5'
    },
    {
      img: 'assets/images/portfolio/gallery-24.jpg',
      title: 'Illustration',
      categories: ['app-development', 'marketing'],
      alt: 'gallery-6'
    }
  ];
  // Portfolio Filter End

  // OWl Slider
    customOptions: OwlOptions = {
      loop: true,
      dots: true,
      margin:30,
      nav:false,
      autoplay:true,
      autoplaySpeed: 2000,
      navSpeed: 2000,
      items: 1,
      navText: ['<i class="bi bi-arrow-left"></i>', '<i class="bi bi-arrow-right"></i>'],
    }
  
    slideStore = [
    {
      title: "Anny Adams",
      subtitle: "CEO/Founder",
      image: "client-1-md.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      title: "Bryan Matt",
      subtitle: "Developer",
      image: "client-2-md.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    },

    {
      title: "David Marks",
      subtitle: "Designer",
      image: "client-3-md.jpg",
      desc:"Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."
    }

  ];

  //Brands
  brands = [
    { img: 'assets/images/brands/brand-1.png', alt: 'brand-1' },
    { img: 'assets/images/brands/brand-2.png', alt: 'brand-2' },
    { img: 'assets/images/brands/brand-3.png', alt: 'brand-3' },
    { img: 'assets/images/brands/brand-4.png', alt: 'brand-4' },
    { img: 'assets/images/brands/brand-5.png', alt: 'brand-5' },
    { img: 'assets/images/brands/brand-6.png', alt: 'brand-6' },
    { img: 'assets/images/brands/brand-7.png', alt: 'brand-7' },
    { img: 'assets/images/brands/brand-8.png', alt: 'brand-8' },
  ];
  //Brands End

  // Skills
  skills = [
    { name: 'Branding', level: 94 },
    { name: 'Social Marketing', level: 89 },
    { name: 'Copy Writing', level: 90 },
    { name: 'Consulting', level: 70 }
  ];
  
  isScrolled = false;

  @HostListener('window:scroll', [])
  onScroll(): void {

    const skillsSection = document.querySelector('.skill');
    
    // Add a null check for skillsSection
    if (skillsSection) {
      const position = skillsSection.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      // Check if the section is in view
      if (position < windowHeight) {
        this.isScrolled = true;
      }
    }
  }

  // Img Carousel
  aboutCarousel:OwlOptions = {
    loop: true,
    dots: true,
    center: true,
    margin:50,
    nav:true,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 1,
    navText: ['<i class="bi bi-arrow-left-short"></i>', '<i class="bi bi-arrow-right-short"></i>'],
  }

  aboutImgs = [
    {img: "slide-md-1.jpg", alt: "Slide 1"},
    {img: "slide-md-2.jpg", alt: "Slide 2"},
    {img: "slide-md-3.jpg", alt: "Slide 3"}
  ];

  // Funfacts
  funFacts =[
    {
      number: 111,
      title: "Projects Won",
      desc:'Aenean commodo ligula eget dolor. Aenean massa.',
      displayedNumber: 0
    },
    {
      number: 74,
      title: "Cups of Coffee",
      desc:'Aenean commodo ligula eget dolor. Aenean massa.',
      displayedNumber: 0
    },
    {
      number: 500,
      title: "Statisfy Clients",
      desc:'Aenean commodo ligula eget dolor. Aenean massa.',
      displayedNumber: 0
    },
    {
      number: 34,
      title: "Awwwards",
      desc:'Aenean commodo ligula eget dolor. Aenean massa.',
      displayedNumber: 0
    }
  ]

  ngOnInit(): void {
    this.startCounters();
  }

  startCounters(): void {
    this.funFacts.forEach(fact => {
      this.animateCounter(fact);
    });
  }

  animateCounter(fact: any): void {
    const duration = 4000; 
    const intervalTime = 50; 
    const increment = fact.number / (duration / intervalTime);

    const interval = setInterval(() => {
      fact.displayedNumber += increment;
      if (fact.displayedNumber >= fact.number) {
        fact.displayedNumber = fact.number;
        clearInterval(interval); 
      }
    }, intervalTime);
  }

  // Portfolio Filter Methods
  filterPortfolio(filter: string): void {
    this.selectedFilter = filter;
  }

  isPortfolioVisible(item: Portfolio): boolean {
    if (this.selectedFilter === 'All') {
      return true;
    }
    const selectedFilterLower = this.selectedFilter.toLowerCase().replace(/\s+/g, '-');
    return item.categories.includes(selectedFilterLower);
  }

  formatCategories(categories: string[]): string {
    return categories.join(', ').replace(/-/g, ' ');
  }
  // Portfolio Filter Methods End

  //Services
  services: Service[] = [
      {
        icon: 'bi-globe',
        title: 'Web Development',
        desc: 'Create responsive and modern websites with the latest technologies.'
      },
      {
        icon: 'bi-eyedropper',
        title: 'UI/UX Design',
        desc: 'Design beautiful and intuitive user interfaces that enhance user experience.'
      },
      {
        icon: 'bi-bar-chart',
        title: 'Digital Marketing',
        desc: 'Boost your online presence with effective marketing strategies and campaigns.'
      }
  ];

  //Blogs
  // Img Carousel
  blogCarousel:OwlOptions = {
    loop: true,
    dots: true,
    margin:50,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 2,
    navText: ['<i class="bi bi-arrow-left-short"></i>', '<i class="bi bi-arrow-right-short"></i>'],
  }

  blogs = [
    {img: "assets/images/blogs/blog-2.jpg", alt: "Blog Post 1", title: "The Power of Small Acts of Kindness", category: "Technology", date: "Apr 29, 2025"},
    {img: "assets/images/blogs/blog-5.jpg", alt: "Blog Post 2", title: "Stay Safe Online", category: "Gaming", date: "May 10, 2025"},
    {img: "assets/images/blogs/blog-6.jpg", alt: "Blog Post 3", title: "Finding Inspiration in the Everyday", category: "Lifestyle", date: "Jun 15, 2025"}
  ];

  // OWl Slider
  brandsCarousel: OwlOptions = {
    loop: true,
    dots: true,
    margin:50,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 6,
    navText: ['<i class="bi bi-arrow-left-short"></i>', '<i class="bi bi-arrow-right-short"></i>'],
  }

  brandStore = [
    {img: "brand-1-white.png"},
    {img: "brand-2-white.png"},
    {img: "brand-3-white.png"},
    {img: "brand-4-white.png"},
    {img: "brand-5-white.png"},
    {img: "brand-6-white.png"}
  ];

  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  // Contact Form
  formData = {
    user_name: '',
    user_email: '',
    message: ''
  };

  // EmailJS service configuration
  private serviceId = 'helifax-form';  // Replace with your EmailJS Service ID
  private templateId = 'helifax-form';  // Replace with your EmailJS Template ID
  private publicKey = 'dOfh1ImCGDZCO9GJb';  // Replace with your EmailJS Public Key

  // Method to send email on form submission
  public sendEmail(event: Event): void {
    event.preventDefault();

    // Send email using EmailJS
    emailjs.sendForm(this.serviceId, this.templateId, event.target as HTMLFormElement, this.publicKey)
      .then(
        (response: EmailJSResponseStatus) => {
          alert('Message sent successfully. Thank you, we will get back to you soon!');
          this.resetForm();
        },
        (error: EmailJSResponseStatus) => {
          console.error('Failed to send message. Error:', error.text);
          alert('Failed to send the message. Please try again later.');
        }
      );
  }

  // Method to reset the form after submission
  private resetForm(): void {
    this.formData = {
      user_name: '',
      user_email: '',
      message: ''
    };
  }
  // Contact Form End

  // Social Icons
  socialLinks = [
    { url: '#', icon: 'bi-facebook', class: 'button-circle-social-facebook' },
    { url: '#', icon: 'bi-twitter-x', class: 'button-circle-social-twitter' },
    { url: '#', icon: 'bi-instagram', class: 'button-circle-social-instagram' }
  ];
}
